<template>
  <div
    v-for="variant in options"
    :key="variant.id"
    tabindex="-1"
    role="option"
    class="my-1 flex cursor-pointer items-center gap-2 px-4 py-2 text-sm transition-colors duration-200 hover:bg-primary/10"
    :class="{
      'active font-bold': active?.id == variant.id
    }"
    @click="$emit('click', variant)"
  >
    <Image
      :src="imgSrc(variant.image.url, 40, 40)"
      img-classes="w-12"
      :lazy-load="true"
      loader="fade"
      :width="40"
      :height="40"
      :alt="variant.title"
      class="w-12 overflow-hidden rounded-full border bg-gray-50"
    />

    <div class="flex flex-col gap-0.5">
      <span
        :class="
          !variant.quantityAvailable
            ? 'text-gray-400 line-through'
            : 'text-black'
        "
        >{{ variant.title }}</span
      >
      <StockIndicator class="text-xs" :in-stock="variant.quantityAvailable" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

import Image from '@/shared/components/UI/Image.vue';
import StockIndicator from '@/shared/components/UI/StockIndicator.vue';
import { Variant } from '@/shared/composables/patternProducts/patternProducts.types';

defineEmits(['click']);

defineProps<{
  options: Variant[];
  active: Variant | null;
}>();

onMounted(() =>
  document.querySelector<HTMLDivElement>('[role="option"].active')?.focus()
);

const imgSrc = (src: string, w: number, h: number) => {
  const url = new URL(src);
  url.searchParams.set('width', w.toString());
  url.searchParams.set('height', h.toString());
  url.searchParams.set('q', '80');
  return url.toString();
};
</script>
